export default __webpack_public_path__ + "static/hireWiseSEO-1437b2b59c599b0c8b0b53e1677c6d87.png";